const StatCard = ({
    title,
    value,
    trend,
    icon: Icon,
    iconColor = 'bg-blue-50 text-blue-600',
    trendColor,
    subtitle,
    showChart = true
}) => {
    const formatTrend = (val) => {
        if (val === undefined || val === null) return null;
        const sign = val >= 0 ? '+' : '';
        return `${sign}${val.toFixed(1)}%`;
    };

    const isPositive = trend !== undefined && trend !== null && trend >= 0;
    const hasTrend = trend !== undefined && trend !== null;

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
            <div className="flex items-start justify-between mb-4">
                <div className="flex-1">
                    <p className="text-sm font-medium text-gray-600 mb-1">{title}</p>
                    <p className="text-3xl font-bold text-gray-900">{typeof value === 'number' ? value.toLocaleString() : value}</p>
                    {subtitle && <p className="text-xs text-gray-500 mt-2">{subtitle}</p>}
                    {hasTrend && (
                        <div className={`flex items-center gap-1 mt-2 text-sm ${trendColor || (isPositive ? 'text-green-600' : 'text-red-600')}`}>
                            {isPositive ? (
                                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clipRule="evenodd" />
                                </svg>
                            ) : (
                                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                            )}
                            <span>{formatTrend(trend)} vs last month</span>
                        </div>
                    )}
                </div>
                {Icon && (
                    <div className={`p-3 rounded-lg ${iconColor}`}>
                        <Icon className={`text-xl ${iconColor.includes('text-') ? '' : 'text-blue-600'}`} />
                    </div>
                )}
            </div>
            {/* Mini bar chart */}
            {showChart && (
                <div className="flex items-end gap-1 h-8 mt-4">
                    {[...Array(12)].map((_, i) => (
                        <div
                            key={i}
                            className="flex-1 bg-gray-200 rounded-t"
                            // Use deterministic heights based on index to avoid hydration mismatch
                            style={{ height: `${30 + (i * 5) % 50}%` }}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default StatCard;

